import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CorpPriceQuoteData } from "redmond";
import {
  fetchCorpUserPassengers,
  setTripPurpose,
  setTripDescription,
  setUserSelectedTravelersList,
  updateUserPassengersMultiple,
} from "../../../actions/actions";

import { IStoreState } from "../../../../../reducers/types";
import { CorpDesktopFlightBookWorkflow } from "./component";
import {
  getCardPaymentAccount,
  getPassengersValidErrors,
  getPassengersValidCallState,
  getPolicyLimit,
  getPriceQuoteWithUpdatedAncillary,
  getUserPassengerCallState,
  getUserSelectedPassengerIds,
  getUserSelectedTravelersList,
  getFdaProductVariant,
} from "../../../reducer";
import { isSinglePageMarketplaceEnabledSelector } from "../../../../ancillary/reducer/selectors";
import {
  getCorporateTravel,
  getShopRequest,
  getViewedTripSummaryProperties,
  selectedFareDetailsSelector,
} from "../../../../shop/reducer/selectors";
import {
  mapStateToProps as baseMapStateToProps,
  mapDispatchToProps as baseMapDispatchToProps,
} from "../../capone/DesktopFlightBookWorkflow/container";
import {
  getRewardsAccountWithLargestEarnForBanner,
  getEarnForHighestEarnRewardsAccount,
} from "../../../../rewards/reducer/selectors";

const mapStateToProps = (state: IStoreState) => ({
  ...baseMapStateToProps(state),
  corporateTravel: getCorporateTravel(state),
  priceQuote: getPriceQuoteWithUpdatedAncillary(state) as CorpPriceQuoteData,
  isSinglePageMarketplaceEnabled: isSinglePageMarketplaceEnabledSelector(state),
  cardPaymentAccount: getCardPaymentAccount(state),
  policyLimit: getPolicyLimit(state),
  fareDetails: selectedFareDetailsSelector(state),
  selectedPaxIds: getUserSelectedPassengerIds(state),
  shopRequest: getShopRequest(state),
  viewedTripSummaryProperties: getViewedTripSummaryProperties(state),
  selectedTravelersList: getUserSelectedTravelersList(state),
  largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  calculatedEarn: getEarnForHighestEarnRewardsAccount(state),
  passengersValidErrors: getPassengersValidErrors(state),
  userPassengerCallState: getUserPassengerCallState(state),
  passengerValidationCallState: getPassengersValidCallState(state),
  fdaProductVariant: getFdaProductVariant(state),
});

const mapDispatchToProps = {
  ...baseMapDispatchToProps,
  setTripPurpose,
  setTripDescription,
  updateUserPassengersMultiple,
  setUserSelectedTravelersList,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CorpDesktopFlightBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const CorpConnectedDesktopFlightBookWorkflow = withRouter(
  connector(CorpDesktopFlightBookWorkflow)
);
